import { RealtyImage } from 'shared/api/kyrgyzstan/search'
import GhostImage from 'shared/images/ghost.png'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

interface GalleryGridProps {
  images: RealtyImage[]
  onImageClick: (index: number) => void
}

export const GalleryGrid = ({ images, onImageClick }: GalleryGridProps) => (
  <div className={s.grid}>
    {images.map((image, index) => (
      <div
        key={image.id}
        className={s.imageWrapper}
        onClick={() => onImageClick(index)}
      >
        <ImageOptimized
          src={image.image_url}
          alt={image.id}
          errorImage={GhostImage}
          className={s.image}
        />
      </div>
    ))}
  </div>
)
